export default {
  lang: 'sv',
  dir: 'ltr',
  common: {
    ok: 'Spara',
    cancel: 'Avbryt',
    key_backspace: 'backsteg',
    key_del: 'radera',
    key_down: 'ner',
    key_up: 'upp',
    more_opts: 'Fler alternativ',
    url: 'URL',
    width: 'Bredd',
    height: 'Höjd'
  },
  misc: {
    powered_by: 'Drivs av'
  },
  ui: {
    toggle_stroke_tools: 'Visa/dölj fler streckverktyg',
    palette_info: 'Klicka för att ändra fyllningsfärg, shift-klicka för att ändra färgar',
    zoom_level: 'Ändra zoomnivå',
    panel_action: 'Klicka för att öppna sidopanelen',
    quality: 'Kvalitet:',
    pathNodeTooltip: 'Dra noden för att flytta den. Dubbelklicka på noden för att ändra segmenttyp',
    pathCtrlPtTooltip: 'Dra kontrollpunkten för att justera kurvegenskaperna',
    pick_stroke_paint_opacity: 'Välj en Stroke Paint och Opacitet',
    pick_fill_paint_opacity: 'Välj en fyllningsfärg och opacitet',
    group_identify_label: 'Gruppidentifieringsetikett',
    export_type_label: 'Välj en bildtyp för export:',
    panel: 'Sidopanel'
  },
  properties: {
    id: 'Identifiera elementet',
    fill_color: 'Ändra fyllningsfärg',
    stroke_color: 'Ändra färgar',
    stroke_style: 'Ändra stroke Dash stil',
    stroke_width: 'Ändra stroke bredd',
    pos_x: 'Ändra X-koordinaten',
    pos_y: 'Ändra Y-koordinaten',
    linecap_butt: 'Linecap: Rumpa',
    linecap_round: 'Linecap: Rund',
    linecap_square: 'Linecap: Fyrkantig',
    linejoin_bevel: 'Linejoin: Fasad',
    linejoin_miter: 'Linejoin: Gering',
    linejoin_round: 'Linejoin: Rund',
    angle: 'Ändra rotationsvinkel',
    blur: 'Ändra gaussisk oskärpa värde',
    opacity: 'Ändra markerat objekt opacitet',
    circle_cx: 'Ändra cirkeln cx samordna',
    circle_cy: 'Ändra cirkeln samordna cy',
    circle_r: 'Ändra cirkelns radie',
    ellipse_cx: 'Ändra ellips&#39;s cx samordna',
    ellipse_cy: 'Ändra ellips&#39;s samordna cy',
    ellipse_rx: 'Ändra ellips&#39;s x radie',
    ellipse_ry: 'Ändra ellips&#39;s y radie',
    line_x1: 'Ändra Lines startar x samordna',
    line_x2: 'Ändra Lines slutar x samordna',
    line_y1: 'Ändra Lines startar Y-koordinat',
    line_y2: 'Ändra Lines slutar Y-koordinat',
    rect_height: 'Ändra rektangel höjd',
    rect_width: 'Ändra rektangel bredd',
    corner_radius: 'Ändra rektangel hörnradie',
    image_width: 'Ändra bild bredd',
    image_height: 'Ändra bildhöjd',
    image_url: 'Ändra URL',
    node_x: 'Ändra nodens x-koordinat',
    node_y: 'Ändra nodens y-koordinat',
    seg_type: 'Ändra segmenttyp',
    straight_segments: 'Rak',
    curve_segments: 'Kurva',
    text_contents: 'Ändra textinnehållet',
    font_family_label: 'Teckensnittsfamilj:',
    font_family: 'Ändra Typsnitt',
    font_size: 'Ändra textstorlek',
    bold: 'Fet text',
    text_decoration_underline: 'Understrykning',
    text_decoration_linethrough: 'Linje genom',
    text_decoration_overline: 'Överlinje',
    italic: 'Kursiv text',
    text_anchor_start: 'Justera texten i början',
    text_anchor_middle: 'Rikta in texten i mitten',
    text_anchor_end: 'Justera texten i slutet',
    text_letter_spacing: 'Ändra bokstavsavståndet',
    text_word_spacing: 'Ändra ordavståndet',
    text_length: 'Låter dig ange bredden på utrymmet som texten ska ritas in i',
    text_length_adjust: 'Längdjustering',
    text_length_adjust_spacing: 'Mellanrum',
    text_length_adjust_spacing_and_glyphs: 'Avstånd och tecken',
    r_label: 'r',
    x_label: 'x',
    y_label: 'y',
    x1_label: 'x1',
    y1_label: 'y1',
    x2_label: 'x2',
    y2_label: 'y2',
    rx_label: 'rx',
    ry_label: 'ry',
    cx_label: 'cx',
    cy_label: 'cy',
    w_label: 'w',
    h_label: 'h',
    id_label: 'Identifierare',
    class_label: 'klass',
    label: 'etikett',
    class: 'Element klass',
    serif: 'Serif',
    sans_serif: 'Sans-serif',
    cursive: 'Cursive',
    fantasy: 'Fantasy',
    monospace: 'Monospace',
    courier: 'Courier',
    helvetica: 'Helvetica',
    times: 'times',
    prefs_and_content: 'Lagra inställningar och SVG-innehåll lokalt',
    prefs_only: 'Lagra endast inställningar lokalt',
    no_prefs_or_content: 'Lagra inte mina inställningar eller SVG-innehåll lokalt',
    jgraduate_pad: 'Vaddera',
    jgraduate_reflect: 'Reflektera',
    jgraduate_repeat: 'Upprepa'
  },
  tools: {
    main_menu: 'Huvudmeny',
    bkgnd_color_opac: 'Ändra bakgrundsfärg / opacitet',
    connector_no_arrow: 'Ingen pil',
    fitToContent: 'Anpassa till innehåll',
    fit_to_all: 'Passar till allt innehåll',
    fit_to_canvas: 'Anpassa till duk',
    fit_to_layer_content: 'Anpassa till lager innehåll',
    fit_to_sel: 'Anpassa till val',
    align_relative_to: 'Justera förhållande till ...',
    relativeTo: 'jämfört:',
    page: 'sida',
    largest_object: 'största objekt',
    selected_objects: 'valda objekt',
    smallest_object: 'minsta objektet',
    export_img: 'Exportera',
    import_doc: 'Importera SVG',
    align_to_page: 'Justera element till sida',
    align_bottom: 'Justera botten',
    align_center: 'Centrera',
    align_left: 'Vänsterjustera',
    align_middle: 'Justera mitten',
    align_right: 'Högerjustera',
    align_top: 'Justera Top',
    mode_select: 'Markeringsverktyget',
    mode_fhpath: 'Pennverktyget',
    mode_line: 'Linjeverktyg',
    mode_rect: 'Rektangelverktyg',
    mode_square: 'Fyrkantigt verktyg',
    mode_fhrect: 'Fri hand rektangel',
    mode_ellipse: 'Ellips',
    mode_circle: 'Cirkel',
    mode_fhellipse: 'Fri hand Ellipse',
    mode_path: 'Sökvägsverktyg',
    mode_text: 'Textverktyg',
    mode_image: 'Bildverktyg',
    mode_zoom: 'Zoomverktyget',
    no_embed: 'OBS: Den här bilden kan inte bäddas in. Det beror på den här sökvägen som ska visas',
    undo: 'Ångra',
    redo: 'Göra om',
    tool_source: 'Redigera källa',
    wireframe_mode: 'Wireframe-läge',
    clone: 'Klona element(er)',
    del: 'Ta bort element',
    group_elements: 'Gruppelement',
    make_link: 'Gör (hyper)länk',
    set_link_url: 'Ange länk-URL (låt vara tomt för att ta bort)',
    to_path: 'Konvertera till sökväg',
    reorient_path: 'Omorientera vägen',
    ungroup: 'Dela Element',
    docprops: 'Dokumentegenskaper',
    editor_homepage: 'SVG-Redigera hemsida',
    move_bottom: 'Flytta till Botten',
    move_top: 'Flytta till början',
    node_clone: 'Klon nod',
    node_delete: 'Radera knutpunkt',
    node_link: 'Länka kontrollpunkter',
    add_subpath: 'Lägg till undersökväg',
    openclose_path: 'Öppna/stäng undersökväg',
    source_save: 'Spara',
    cut: 'Skära',
    copy: 'Kopiera',
    paste: 'Klistra',
    paste_in_place: 'Klistra in på plats',
    delete: 'Radera',
    group: 'Grupp',
    move_front: 'Ta fram',
    move_up: 'Ta fram',
    move_down: 'Skicka bakåt',
    move_back: 'Skicka tillbaka',
    tool_unlink_use: 'Bryt länk till referenselement (gör unik)',
    ellipse_circle_tool: 'Ellips/Cirkel Verktyg',
    square_rect_tool: 'Fyrkant/Rect Verktyg',
    remember_this_choice: 'Kommer du ihåg detta val?',
    remember_this_choice_title: 'Om du väljer att välja bort lagring samtidigt som du kommer ihåg detta val kommer webbadressen att ändras för att undvika att fråga igen.',
    flip_horizontal: 'Vänd horisontellt',
    flip_vertical: 'Vänd vertikalt'
  },
  layers: {
    layer: 'Lager',
    layers: 'Skikten',
    del: 'Radera Lager',
    move_down: 'Flytta lager nedåt',
    new: 'Nytt lager',
    rename: 'Byt namn på lager',
    move_up: 'Flytta lager upp',
    dupe: 'Duplicera lager',
    merge_down: 'Sammanfoga ner',
    merge_all: 'Slå samman alla',
    move_elems_to: 'Flytta element till:',
    move_selected: 'Flytta markerade element till ett annat lager'
  },
  config: {
    image_props: 'Bildegenskaper',
    doc_title: 'Titel',
    doc_dims: 'Canvas mått',
    included_images: 'Inkluderade bilder',
    image_opt_embed: 'Bädda in data (lokala filer)',
    image_opt_ref: 'Använd filreferens',
    editor_prefs: 'Redaktörsinställningar',
    language: 'Språk',
    background: 'Redaktör bakgrund',
    editor_img_url: 'bild URL',
    editor_bg_note: 'Obs: Bakgrunden kommer inte att sparas med bilden.',
    select_predefined: 'Välj fördefinierad:',
    units_and_rulers: 'Enheter och linjaler',
    show_rulers: 'Visa linjaler',
    base_unit: 'Basenhet:',
    grid: 'Rutnät',
    snapping_onoff: 'Knäppning på/av',
    snapping_stepsize: 'Snäppsteg-storlek:',
    grid_color: 'Rutnätsfärg',
    done: 'Gjort',
    change_xxx_color: 'Ändra xxx färg',
    pick_paint_opavity: 'Välj en {{newValue}} färg och opacitet',
    open_color_picker: 'Klicka för att öppna färgväljaren',
    jpicker_title: 'Dra markörer för att välja en färg',
    jpicker_new_color: 'ny',
    jpicker_current_color: 'nuvarande',
    jpicker_tooltip_colors_new_color: 'Ny färg - Tryck &ldquo;OK&rdquo; Att begå',
    jpicker_tooltip_colors_current_color: 'Klicka för att återgå till originalfärg',
    jpicker_tooltip_buttons_ok: 'Förbinder dig till detta färgval',
    jpicker_tooltip_buttons_cancel: 'Avbryt och återställ till originalfärg',
    jpicker_tooltip_hue_radio: 'Ställ in på &ldquo;Nyans&rdquo;-färgläge',
    jpicker_tooltip_hue_textbox: 'Ange ett &ldquo;Nyans&rdquo;-värde (0-360&deg;)',
    jpicker_tooltip_saturation_radio: 'Ställ in på &ldquo;Mättnad&rdquo;-färgläge',
    jpicker_tooltip_saturation_textbox: 'Ange ett &ldquo;Mättnad&rdquo;-värde (0-100%)',
    jpicker_tooltip_value_radio: 'Ställ in på &ldquo;Värde&rdquo;-färgläge',
    jpicker_tooltip_value_textbox: 'Ange ett &ldquo;Värde&rdquo;-värde (0-100%)',
    jpicker_tooltip_red_radio: 'Ställ in på &ldquo;Röd&rdquo;-färgläge',
    jpicker_tooltip_red_textbox: 'Ange ett &ldquo;Röd&rdquo;-värde (0-255)',
    jpicker_tooltip_green_radio: 'Ställ in på &ldquo;Grön&rdquo;-färgläge',
    jpicker_tooltip_green_textbox: 'Ange ett &ldquo;Grön&rdquo;-värde (0-255)',
    jpicker_tooltip_blue_radio: 'Ställ in på &ldquo;Blå&rdquo;-färgläge',
    jpicker_tooltip_blue_textbox: 'Ange ett &ldquo;Blå&rdquo;-värde (0-255)',
    jpicker_tooltip_alpha_radio: 'Ställ in på &ldquo;Alfa&rdquo;-färgläge',
    jpicker_tooltip_alpha_textbox: 'Ange ett &ldquo;Alfa&rdquo;-värde (0-100)',
    jpicker_tooltip_hex_textbox: 'Ange ett &ldquo;Hex&rdquo;-färgvärde (#000000-#ffffff)',
    jpicker_tooltip_hex_alpha: 'Ange ett &ldquo;Alfa&rdquo;-värde (#00-#ff)',
    jgraduate_solid_color: 'Enfärgade',
    jgraduate_linear_gradient: 'Linjär gradient',
    jgraduate_radial_gradient: 'Radiell gradient',
    jgraduate_begin_point: 'Startpunkt',
    jgraduate_enter_starting_x: 'Ange ett startvärde för x mellan 0,0 och 1,0',
    jgraduate_enter_starting_y: 'Ange ett startvärde för y mellan 0,0 och 1,0',
    jgraduate_end_point: 'Slutpunkt',
    jgraduate_enter_ending_x: 'Ange ett slutvärde för x mellan 0,0 och 1,0',
    jgraduate_enter_ending_y: 'Ange slutvärdet y mellan 0,0 och 1,0',
    jgraduate_center_point: 'Mittpunkt',
    jgraduate_enter_value_x: 'Ange ett x-värde mellan 0,0 och 1,0',
    jgraduate_enter_value_y: 'Ange ett y-värde mellan 0,0 och 1,0',
    jgraduate_focal_point: 'Brännpunkt',
    jgraduate_match_center: 'Matchcenter:',
    jgraduate_enter_focal_x: 'Ange ett x-värde mellan 0,0 och 1,0',
    jgraduate_enter_focal_y: 'Ange ett y-värde mellan 0,0 och 1,0',
    jgraduate_spread_method: 'Spridningsmetod',
    jgraduate_radius: 'Radie:',
    jgraduate_set_radius: 'Klicka för att ställa in radie',
    jgraduate_ellip: 'Ellip:',
    jgraduate_set_ellip: 'Klicka för att ställa in Ellip',
    jgraduate_angle: 'Vinkel:',
    jgraduate_set_angle: 'Klicka för att ställa in vinkel',
    jgraduate_deg: 'grad:',
    jgraduate_opac: 'Opac:',
    jgraduate_set_opac: 'Klicka för att ställa in Opac'
  },
  notification: {
    invalidAttrValGiven: 'Ogiltigt värde angett',
    noContentToFitTo: 'Inget innehåll att passa till',
    dupeLayerName: 'Det finns redan ett lager som heter det!',
    enterUniqueLayerName: 'Ange ett unikt lagernamn',
    enterNewLayerName: 'Ange det nya lagrets namn',
    layerHasThatName: 'Layer har redan det namnet',
    QmoveElemsToLayer: "Flytta markerade element till lagret '%s'?",
    QwantToClear: 'Vill du rensa ritningen?\n' +
      'Detta kommer också att radera din ångringshistorik!',
    QwantToOpen: 'Vill du öppna en ny fil?\n' +
      'Detta kommer också att radera din ångringshistorik!',
    QerrorsRevertToSource: 'Det fanns analysfel i din SVG-källa.\n' +
      'Återgå tillbaka till den ursprungliga SVG-källan?',
    QignoreSourceChanges: 'Ignorera ändringar som gjorts i SVG-källan?',
    featNotSupported: 'Funktionen stöds inte',
    enterNewImgURL: 'Ange den nya bildens URL',
    defsFailOnSave: 'OBS: På grund av ett fel i din webbläsare kan den här bilden verka fel (saknade övertoningar eller element). Det kommer dock att verka korrekt när det väl har sparats.',
    loadingImage: 'Laddar bild, vänta...',
    saveFromBrowser: "Välj 'Spara som...' i din webbläsare (möjligen via filmenyn eller högerklicka på snabbmenyn) för att spara den här bilden som en {{typ}}-fil.",
    noteTheseIssues: 'Observera även följande problem: ',
    unsavedChanges: 'Det finns ändringar som inte har sparats.',
    enterNewLinkURL: 'Ange den nya hyperlänkens URL',
    errorLoadingSVG: 'Fel: Det gick inte att ladda SVG-data',
    URLLoadFail: 'Det gick inte att ladda från URL',
    retrieving: "Hämtar '%s' ...",
    popupWindowBlocked: 'Popup-fönster kan blockeras av webbläsaren',
    exportNoBlur: 'Suddiga element kommer att visas som oskarpa',
    exportNoforeignObject: 'foreignObject-element kommer inte att visas',
    exportNoDashArray: 'Strokes kommer att visas fyllda',
    exportNoText: 'Text kanske inte visas som förväntat',
    editorPreferencesMsg: 'Som standard och där det stöds kan SVG-Edit lagra dina redigeringsinställningar och SVG-innehåll lokalt på din maskin så att du inte behöver lägga till dessa igen varje gång du laddar SVG-Edit. Om du av integritetsskäl inte vill lagra denna information på din maskin kan du byta bort från standardalternativet nedan.',
    source_dialog_note: 'Kopiera innehållet i den här rutan till en textredigerare och spara sedan filen med filtillägget .svg.'
  }
}
